import { Undo2 } from 'lucide-react';

import { useFocusRequest } from './use-focus-request';

import '../venue-booking-content.css';

export interface PhotoRemoveButtonsProps {
  hasImportedPhoto: boolean;
  busy: boolean;
  phone: boolean;
  buttonHeight: number;
  focusRequested: boolean;
  onFocused: () => void;
  onKeep: () => void;
  onRemove: () => void;
}

function removeLabel(hasImportedPhoto: boolean, busy: boolean): string {
  if (hasImportedPhoto) return busy ? 'Reverting…' : 'Revert to imported photo';
  return busy ? 'Removing…' : 'Remove photo';
}

/** Keep the uploaded photo, or go ahead and remove it. */
export function PhotoRemoveButtons({
  hasImportedPhoto,
  busy,
  phone,
  buttonHeight,
  focusRequested,
  onFocused,
  onKeep,
  onRemove,
}: PhotoRemoveButtonsProps) {
  const keepButton = useFocusRequest<HTMLButtonElement>(focusRequested, onFocused);
  const style = {
    height: buttonHeight,
    fontSize: 12.5,
    justifyContent: 'center',
    whiteSpace: 'nowrap',
  } as const;
  return (
    <div
      style={{
        display: 'flex',
        gap: 8,
        justifyContent: phone ? 'stretch' : 'flex-end',
        flexDirection: phone ? 'column-reverse' : 'row',
      }}
    >
      <button
        ref={keepButton}
        type="button"
        className="nb-btn nb-btn-ghost"
        disabled={busy}
        onClick={onKeep}
        style={style}
      >
        Keep uploaded photo
      </button>
      <button
        type="button"
        className="nb-btn vbc-danger-btn"
        disabled={busy}
        onClick={onRemove}
        style={style}
      >
        {hasImportedPhoto && <Undo2 size={12} aria-hidden="true" />}
        {removeLabel(hasImportedPhoto, busy)}
      </button>
    </div>
  );
}
